import getUrlPath from '../../../utils/getUrlPath';
import useCategories from '../../../hooks/useCategories';
import { Category } from '../../../types/categories';
import { categoryAttributes, HIDE_CATEGORY_CARD } from '../../../constants/categories';
import { ComponentType, useState } from 'react';
import { url } from '../../../constants/url';
import { useEffect } from 'react';
import { sortCategoriesByPopularityInCategory } from '../../../utils/categories';

interface CategoryContextProviderProps {
  parentCategorySlug: string;
  cardIndex: string;
  updateCategoryCardHref?: boolean;
}

function categoryContextProvider<T>(Child: ComponentType<T & CategoryContextProviderProps>) {
  return function ContextProvider(props: T & CategoryContextProviderProps) {
    const { parentCategorySlug, cardIndex, updateCategoryCardHref } = props;
    const { category } = useCategories(parentCategorySlug);

    const [subCategory, setSubCategory] = useState<Category | undefined>();

    const queryCard = () => {
      const typeAttribute = `${categoryAttributes.keys.elementType}="${categoryAttributes.values.categoryCard}"`;
      const slugAttribute = `${categoryAttributes.keys.parentSlug}="${parentCategorySlug}"`;
      const indexAttribute = `${categoryAttributes.keys.cardIndex}="${cardIndex}"`;
      return document.querySelector(`a[${typeAttribute}][${slugAttribute}][${indexAttribute}]`);
    };

    const updateHref = (category: Category) => {
      const hrefBase = getUrlPath(url.rental.subPath.categories);
      const element = queryCard();
      if (element) {
        (element as HTMLAnchorElement).setAttribute('href', `${hrefBase}/${category.slug}`);
      }
    };

    const hideCard = () => {
      const element = queryCard();
      element?.classList.add(HIDE_CATEGORY_CARD);
    };

    const getSortedSubcategories = (category: Category) => {
      return category.subCategories?.slice().sort(sortCategoriesByPopularityInCategory);
    };

    useEffect(() => {
      if (!category) {
        return;
      }
      const subCategories = getSortedSubcategories(category);

      const subCategoryFound = Array.isArray(subCategories)
        ? subCategories[Number(cardIndex)]
        : undefined;

      if (!subCategoryFound) {
        hideCard();
        return;
      }
      updateCategoryCardHref && updateHref(subCategoryFound);
      setSubCategory(subCategoryFound);
    }, [category, parentCategorySlug, cardIndex, updateCategoryCardHref]);

    if (!subCategory) {
      return null;
    }

    return <Child {...props} slug={subCategory.slug} />;
  };
}

export default categoryContextProvider;
